module.exports = __webpack_public_path__ + "static/media/tt.27c618af.svg";